





















import { Component, Vue } from "vue-property-decorator";
import Header from "./Header.vue";
import Sidebar from "./Sidebar.vue";

@Component({
    components: {
        Sidebar,
        Header
    }
})
export default class Layout extends Vue {
    sideBarShrink = false as boolean;
}
